import { createFetcher } from "api/helpers"

const fetcherConfiguration = {
  method: "post",
  makeRequestUrl: (host, projectId) => {
    return `${host}/itsm/${projectId}/update_zeroday_ritm`
  },
  checkRequiredArguments: () => {},
  makeResponseData: (json) => {
    return json
  },
  returnRawResponse: true
}
export default createFetcher(fetcherConfiguration)
